var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main_content_wrapper" },
    [
      _c("sdl-breadcrumb", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ]
      }),
      _vm._v(" "),
      _c("div", { staticClass: "com_head" }, [
        _c("h4", {
          staticClass: "main_title",
          domProps: { innerHTML: _vm._s(_vm.welcomeTitle) }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "button" }, [
          _c("label", { staticClass: "info" }, [
            _vm._v(_vm._s(_vm.userTimezone))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dp_main_flex" }, [
        _c("div", { staticClass: "dp_block cols_75" }, [
          _c("div", { staticClass: "block_line" }, [
            _c("div", { staticClass: "list_wrap" }, [
              _c("div", { staticClass: "com_head" }, [
                _c("h4", [_vm._v(_vm._s(_vm.$t("cop.home.title.myproject")))]),
                _vm._v(" "),
                _c("button", {
                  staticClass: "btn btn_icon ico_link",
                  attrs: { title: "More" },
                  on: {
                    click: function($event) {
                      return _vm.onMenuLinkClick(_vm.menuLinks["myProject"])
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "scop_grid h_auto",
                  staticStyle: { height: "203px" }
                },
                [
                  _c(
                    "table",
                    {
                      directives: [
                        { name: "columnResize", rawName: "v-columnResize" }
                      ]
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("thead", [
                        _c("tr", [
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("cop.home.label.projectName")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("cop.home.label.projectLeader"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("cop.home.label.csp")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("cop.home.label.environment")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("cop.home.label.accountId")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("cop.home.label.user")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("cop.home.label.role")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "th",
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("cop.home.label.status")) +
                                  "\n                  "
                              ),
                              _c(
                                "v-popover",
                                {
                                  attrs: {
                                    trigger: "hover",
                                    boundariesElement: "window"
                                  }
                                },
                                [
                                  _c("button", {
                                    staticClass: "btn btn_icon ico_tooltip",
                                    attrs: { type: "button" }
                                  }),
                                  _vm._v(" "),
                                  _c("template", { slot: "popover" }, [
                                    _c("div", { staticClass: "tooltip_con" }, [
                                      _c("ul", [
                                        _c("li", [
                                          _c(
                                            "span",
                                            { staticClass: "st_label major" },
                                            [_vm._v("DRAFT")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "span",
                                            { staticClass: "st_label review" },
                                            [_vm._v("INREVIEW")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "span",
                                            { staticClass: "st_label active" },
                                            [_vm._v("ACTIVE")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "st_label inactive"
                                            },
                                            [_vm._v("INACTIVE")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "span",
                                            { staticClass: "st_label drop" },
                                            [_vm._v("DROP")]
                                          )
                                        ])
                                      ])
                                    ])
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.projectList && _vm.projectList.length > 0
                        ? _c(
                            "tbody",
                            _vm._l(_vm.projectList, function(row, idx) {
                              return _c(
                                "tr",
                                {
                                  key: idx,
                                  staticClass: "link",
                                  on: {
                                    click: function($event) {
                                      return _vm.onMyProjectDetailClick(row)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "tl link",
                                      attrs: { title: row.projectName }
                                    },
                                    [_vm._v(_vm._s(row.projectName))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      class: { tl: row.projectLeader },
                                      attrs: {
                                        title: row.projectLeader
                                          ? row.projectLeader +
                                            " (" +
                                            row.projectLeaderKnoxId +
                                            ")"
                                          : "-"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.projectLeader
                                            ? row.projectLeader +
                                                " (" +
                                                row.projectLeaderKnoxId +
                                                ")"
                                            : "-"
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td", { attrs: { title: row.cspName } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._.isEmpty(row.cspName)
                                          ? "-"
                                          : row.cspName
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { title: row.envName } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._.isEmpty(row.envName)
                                          ? "-"
                                          : row.envName
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      class: {
                                        tl: !_vm._.isEmpty(row.accountId)
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._.isEmpty(row.accountId)
                                            ? "-"
                                            : row.accountId
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "link",
                                      attrs: { title: row.memberCount },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.onMyProjectDetailClick(row)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(row.memberCount))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "link",
                                      attrs: { title: row.roleCount },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.onMenuLinkClick(
                                            _vm.menuLinks["myProjectRole"]
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(row.roleCount))]
                                  ),
                                  _vm._v(" "),
                                  _c("td", {
                                    attrs: { title: row.projectState },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        row.projectStateBeautify
                                      )
                                    }
                                  })
                                ]
                              )
                            }),
                            0
                          )
                        : _c("tbody", [
                            _c("tr", [
                              _c("td", { attrs: { colspan: "8" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("sdl.common.message.noResult"))
                                )
                              ])
                            ])
                          ])
                    ]
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dp_block" }, [
          _c("div", { staticClass: "block_line" }, [
            _c("div", { staticClass: "com_head" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("cop.home.title.mycsp")))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "download_wrap" }, [
              _c("div", { staticClass: "download_list" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn_client_download bg_none on",
                    attrs: { type: "button" }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.home.label.mycsp.cspLogin")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_down_linked aws",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onCspLoginClick(
                          "AWS",
                          _vm.cspLinks["aws"],
                          true
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.home.label.mycsp.awsConsole")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_down_linked azure",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onCspLoginClick(
                          "Azure",
                          _vm.cspLinks["azure"],
                          true
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.home.label.mycsp.azureConsole")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_down_linked gcp",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onCspLoginClick(
                          "GCP",
                          _vm.cspLinks["gcp"],
                          true
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.home.label.mycsp.gcpConsole")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_down_linked oci",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onCspLoginClick(
                          "OCI",
                          _vm.cspLinks["oci"],
                          true
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.home.label.mycsp.ociConsole")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_down_linked ncp",
                    attrs: { type: "button" },
                    on: { click: _vm.ncpPopup }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.home.label.mycsp.ncpConsole")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_down_linked ali",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onCspLoginClick(
                          "ALI",
                          _vm.cspLinks["ali"],
                          true
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.home.label.mycsp.aliConsole")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_down_linked ali",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onCspLoginClick(
                          "ALI_CN",
                          _vm.cspLinks["ali_cn"],
                          true
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.home.label.mycsp.alicnConsole")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_down_linked scp",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onCspLoginClick(
                          "SCP",
                          _vm.cspLinks["scp"],
                          true
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.home.label.mycsp.scpConsole")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_down_linked aws",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onCspLoginClick(
                          "AWS_CN",
                          _vm.cspLinks["aws_cn"],
                          true
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.home.label.mycsp.awscnConsole")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_down_linked spc",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onCspLoginClick(
                          "SPC",
                          _vm.cspLinks["spc"],
                          true
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cop.home.label.mycsp.spcConsole")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_down_linked azure",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onCspLoginClick(
                          "Azure China",
                          _vm.cspLinks["azure_cn"],
                          true
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("cop.home.label.mycsp.azureCnConsole"))
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dp_main_flex" }, [
        _c("div", { staticClass: "dp_block cols_100" }, [
          _c("div", { staticClass: "block_line" }, [
            _c("div", { staticClass: "list_wrap" }, [
              _c("div", { staticClass: "com_head" }, [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("cop.home.title.myworkrequest")))
                ]),
                _vm._v(" "),
                _c("button", {
                  staticClass: "btn btn_icon ico_link",
                  attrs: { title: "More" },
                  on: {
                    click: function($event) {
                      return _vm.onMenuLinkClick(_vm.menuLinks["myWorkRequest"])
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "scop_grid h_auto",
                  staticStyle: { height: "162px" }
                },
                [
                  _c("table", [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cop.home.label.requestType")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cop.home.label.projectName")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cop.home.label.requestedBy")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("cop.home.label.requestedDate")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "th",
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$t("cop.home.label.approvalStatus")
                                ) +
                                "\n                  "
                            ),
                            _c(
                              "v-popover",
                              {
                                attrs: {
                                  trigger: "hover",
                                  boundariesElement: "window"
                                }
                              },
                              [
                                _c("button", {
                                  staticClass: "btn btn_icon ico_tooltip",
                                  attrs: { type: "button" }
                                }),
                                _vm._v(" "),
                                _c("template", { slot: "popover" }, [
                                  _c("div", { staticClass: "tooltip_con" }, [
                                    _c("ul", [
                                      _c("li", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "st_label inprogress"
                                          },
                                          [_vm._v("In Progress")]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "span",
                                          { staticClass: "st_label rejected" },
                                          [_vm._v("Rejected")]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "span",
                                          { staticClass: "st_label completed" },
                                          [_vm._v("Completed")]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "span",
                                          { staticClass: "st_label submitted" },
                                          [_vm._v("Cancelled")]
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("cop.home.label.requestStatus")) +
                                "\n                  "
                            ),
                            _c(
                              "v-popover",
                              {
                                attrs: {
                                  trigger: "hover",
                                  boundariesElement: "window"
                                }
                              },
                              [
                                _c("button", {
                                  staticClass: "btn btn_icon ico_tooltip",
                                  attrs: { type: "button" }
                                }),
                                _vm._v(" "),
                                _c("template", { slot: "popover" }, [
                                  _c("div", { staticClass: "tooltip_con" }, [
                                    _c("ul", [
                                      _c("li", [
                                        _c(
                                          "span",
                                          { staticClass: "st_bg inprogress" },
                                          [_vm._v("In Progress")]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "span",
                                          { staticClass: "st_bg completed" },
                                          [_vm._v("Completed")]
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.workRequestList && _vm.workRequestList.length > 0
                      ? _c(
                          "tbody",
                          _vm._l(_vm.workRequestList, function(row, idx) {
                            return _c(
                              "tr",
                              {
                                key: idx,
                                staticClass: "link",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.onMyWorkRequestDetailClick(row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "tl",
                                    attrs: { title: row.requestType }
                                  },
                                  [_vm._v(_vm._s(row.requestType))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: {
                                      tl: !_vm._.isEmpty(row.projectName)
                                    },
                                    attrs: { title: row.projectName }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._.isEmpty(row.projectName)
                                          ? "-"
                                          : row.projectName
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "tl",
                                    attrs: {
                                      title: row.requestBy
                                        ? row.requestBy +
                                          " (" +
                                          row.requestByKnoxId +
                                          ")"
                                        : "SYSTEM"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        row.requestBy
                                          ? row.requestBy +
                                              " (" +
                                              row.requestByKnoxId +
                                              ")"
                                          : "SYSTEM"
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      title: _vm._f("dateFormat")(
                                        row.requestDate
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFormat")(row.requestDate)
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", {
                                  attrs: { title: row.approvalStatus },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      row.approvalStatusBeautify
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("td", {
                                  attrs: { title: row.requestStatus },
                                  domProps: {
                                    innerHTML: _vm._s(row.requestStatusBeautify)
                                  }
                                })
                              ]
                            )
                          }),
                          0
                        )
                      : _c("tbody", [
                          _c("tr", [
                            _c("td", { attrs: { colspan: "6" } }, [
                              _vm._v(
                                _vm._s(_vm.$t("sdl.common.message.noResult"))
                              )
                            ])
                          ])
                        ])
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dp_main_flex" }, [
        _c("div", { staticClass: "dp_block cols_25" }, [
          _c("div", { staticClass: "block_line" }, [
            _c("div", { staticClass: "com_head" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("cop.home.title.notice")))]),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn btn_icon ico_link",
                attrs: { title: "More" },
                on: {
                  click: function($event) {
                    return _vm.onMenuLinkClick(_vm.menuLinks["boardNotice"])
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm.noticeList && _vm.noticeList.length > 0
              ? _c(
                  "ul",
                  _vm._l(_vm.noticeList, function(row, idx) {
                    return _c(
                      "li",
                      {
                        key: idx,
                        class: [row.deleteYn ? "no_exist" : ""],
                        on: {
                          click: function($event) {
                            return _vm.onBoardNoticeDetailClick(row)
                          }
                        }
                      },
                      [
                        _c("p", { attrs: { title: row.postTitle } }, [
                          _vm._v(_vm._s(row.postTitle))
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            attrs: {
                              title: _vm._f("dateFormat")(row.registDate)
                            }
                          },
                          [_vm._v(_vm._s(_vm._f("dateFormat")(row.registDate)))]
                        )
                      ]
                    )
                  }),
                  0
                )
              : _c("ul", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("sdl.common.message.noResult")) +
                      "\n        "
                  )
                ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dp_block cols_25" }, [
          _c("div", { staticClass: "block_line" }, [
            _c("div", { staticClass: "com_head" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("cop.home.title.qna")))]),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn btn_icon ico_link",
                on: {
                  click: function($event) {
                    return _vm.onMenuLinkClick(_vm.menuLinks["boardQna"])
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm.qnaList && _vm.qnaList.length > 0
              ? _c(
                  "ul",
                  _vm._l(_vm.qnaList, function(row, idx) {
                    return _c(
                      "li",
                      {
                        key: idx,
                        class: [
                          !row.publicYn ? "secret" : "",
                          row.deleteYn ? "no_exist" : ""
                        ],
                        on: {
                          click: function($event) {
                            return _vm.onBoardQnaDetailClick(row)
                          }
                        }
                      },
                      [
                        _c("p", { attrs: { title: row.postTitle } }, [
                          _vm._v(_vm._s(row.postTitle))
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            attrs: {
                              title: _vm._f("dateFormat")(row.registDate)
                            }
                          },
                          [_vm._v(_vm._s(_vm._f("dateFormat")(row.registDate)))]
                        )
                      ]
                    )
                  }),
                  0
                )
              : _c("ul", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("sdl.common.message.noResult")) +
                      "\n        "
                  )
                ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dp_block cols_25" }, [
          _c("div", { staticClass: "block_line" }, [
            _c("div", { staticClass: "com_head" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("cop.home.title.tutorial")))])
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "start_tutorial" },
              _vm._l(_vm.tutorialList, function(row, idx) {
                return _c(
                  "li",
                  {
                    key: idx,
                    on: {
                      click: function($event) {
                        return _vm.onTutorialClick(row)
                      }
                    }
                  },
                  [
                    _c("p", { attrs: { title: row.title } }, [
                      _vm._v(_vm._s(row.title))
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dp_block cols_25" }, [
          _c("div", { staticClass: "block_line" }, [
            _c("div", { staticClass: "com_head" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("cop.home.title.quickLinks")))])
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "quick_link" },
              _vm._l(_vm.quickLinkList, function(row, idx) {
                return _c(
                  "li",
                  {
                    key: idx,
                    on: {
                      click: function($event) {
                        return _vm.onQuickLinkClick(row)
                      }
                    }
                  },
                  [
                    _c("p", { attrs: { title: row.title } }, [
                      _vm._v(_vm._s(row.title))
                    ])
                  ]
                )
              }),
              0
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "140px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "180px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "260px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "120px" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "180px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "220px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "140px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "150px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "120px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "120px" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13966bdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13966bdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/MainIndexPage.vue
// module id = null
// module chunks = 